import React from 'react'
import { Card } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { getMaterial } from '../../modules/material'
import TransactionTab from '../Brand/BrandActivity/BrandActivityDetail/TransactionTab'

const BrandActivityTransaction = () => {
  const dispatch = useDispatch()

  const { materials } = useSelector(
    (state) => ({
      materials: (state.material.material && state.material.material.data) || []
    }),
    []
  )

  useDeepEffect(() => {
    if (materials.length === 0) {
      dispatch(getMaterial())
    }
  }, [])

  return (
    <Card title="Brand Activity">
      <TransactionTab materials={materials} />
    </Card>
  )
}

export default BrandActivityTransaction
